export default __webpack_public_path__ + "static/media/icon-contact-chat@2x.82b70c9d.svg";